export const apiHost: string = process.env.NODE_ENV === "production" ? "https://my.liveportrait.com" : "http://0.0.0.0:8887";
export const apiKey = 'ca0d05e9-281b-494f-9653-bbca4f302e63'